import { Injectable } from '@angular/core';
import { Location } from '@ml/locations/types';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {
  private readonly URL = `https://www.google.com/maps/dir/?api=1`;

  constructor() {}

  navigateTo(location: Location) {
    let url = this.URL;
    if (location.startPoint) {
      url += `&travelmode=driving&destination=${location.startPoint.lat},${
        location.startPoint.long
      }`;
    } else {
      url += `&travelmode=driving&destination=${encodeURI(
        location.name.replace(/ /g, '')
      )}`;
    }
    window.open(url, '_blank');
  }
}
